import { useCallback, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import tooltipIcon from '../../../../../assets/image/tooltip_vendor name.png';
import { getCustomerList } from '../../../../../services/customers';
import CustomDrawer from '../../../components/customDrawer';
import AddCustomerModel from '../../invoice/components/addCustomerModel';
import InputSelect from '../../../../../component/inputSelect/InputSelect';
import InputField from '../../../../../component/form/FormInput';
import { getCurrentDate, getDate } from '../../../../../utils/dateUtils';
import Modal from '../../../../../component/modal/Modal';
import Button from '../../../../../component/ui/Button';
import { format, parseISO } from 'date-fns';
import {
	fetchCreditNoteDetails,
	fetchCreditNoteExcessPayment,
	fetchCreditNoteNumber,
} from '../../../../../services/sales_credit_note';
import Multiselect from 'multiselect-react-dropdown';
import './createCreditNoteStyle.scss';
import { fetchSalesReturnDetails, getSalesReturnList } from '../../../../../services/sales_return';

const CreditNoteForm = ({
	creditNote,
	error,
	setError,
	setCreditNote,
	setCreditNoteTable,
	creditNoteTable,
	salesReturnNumbers,
	setSalesReturnNumbers,
}) => {
	const location = useLocation();
	const param = useParams();
	const id = param?.id;
	const [creditNoteTypeList, setCreditNoteTypeList] = useState([
		{ key: 1, value: 'Damaged/Return Goods' },
		{ key: 2, value: 'Excess Payment' },
		{ key: 3, value: 'Advance Payment' },
	]);
	const [customerList, setCustomerList] = useState([]);
	const [salesReturnList, setSalesReturnList] = useState([]);
	const [isAddCustomerModalOpen, setIsAddCustomerModalOpen] = useState(false);
	const [isReferencesFocus, setIsReferencesFocus] = useState(false);
	const [searchCustomer, setSearchCustomer] = useState(false);
	const [isOpenPastDate, setIsOpenPastDate] = useState(false);
	const [isUsedPastDate, setIsUsedPastDate] = useState(false);
	const [isDateFocus, setIsDateFocus] = useState(false);
	const [drawerType, setDrawerType] = useState('');
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);
	const [autofocus, setAutofocus] = useState(false);
	const [params, setParams] = useState({
		customer: {
			status: 1,
			page: 1,
			pageSize: 10000,
			dropdown: true,
			orderBy: null,
			sortBy: null,
			filterBy: null,
			filterValue: null,
		},
		doctor: {
			status: 1,
			page: 1,
			pageSize: 10000,
			dropdown: true,
			orderBy: null,
			sortBy: null,
			filterBy: null,
			filterValue: null,
		},
	});
	const handleFormData = (type, value) => {
		setCreditNote((prev) => ({
			...prev,
			[type]: value,
		}));

		let newError = { ...error };
		if (type === 'customer_id') {
			if (value === '' || value === null || value === undefined) {
				newError[type] = 'Please select valid  customer name from the list';
			} else {
				delete newError[type];
			}
		}

		if (type === 'amount_paid') {
			if (value === '' || value === null || value === undefined) {
				newError[type] = 'Please enter Amount Paid in the fields';
			} else {
				delete newError[type];
			}
		}
		if (type === 'credit_note_type') {
			if (value === '' || value === null || value === undefined) {
				newError[type] = 'Please select valid  credit note type from the list';
			} else {
				delete newError[type];
			}
		}
		if (creditNote.credit_note_type === 1) {
			if (type === 'sales_return_number') {
				if (value === '' || value === null || value === undefined) {
					newError[type] = 'Please select valid  sales return number from the list';
				} else {
					delete newError[type];
				}
			}
		}
		setError(newError);
	};

	const confirmUsedPastDate = () => {
		const newError = { ...error };
		delete newError.date;
		setError(newError);
		setIsUsedPastDate(true);
		setIsOpenPastDate(false);
		setIsReferencesFocus(true);
	};

	const cancelUsedPastDate = () => {
		setCreditNote((prev) => ({
			...prev,
			date: getCurrentDate(),
		}));
		setIsOpenPastDate(false);
		setIsDateFocus(true);
	};

	const handleFetchCustomerList = useCallback(async () => {
		try {
			const { customers } = await getCustomerList(params?.customer);
			const customerOptionList = customers?.map((customer) => {
				return {
					key: customer?.id,
					value: customer?.name,
				};
			});
			setCustomerList(customerOptionList);
		} catch (error) {
			toast.error(error.message ?? 'Something went wrong!');
		}
	}, [params?.customer]);

	useEffect(() => {
		let timer = setTimeout(() => {
			setParams((prev) => ({
				...prev,
				customer: {
					...prev.customer,
					filterBy: 'name',
					filterValue: searchCustomer,
					status: 1,
				},
			}));
		}, 500);
		return () => clearTimeout(timer);
	}, [searchCustomer]);

	useEffect(() => {
		if (!creditNote.customer_id) {
			handleFetchCustomerList();
		}
	}, [params.customer, id, creditNote.customer_id]);
	async function handleFetchCreditNoteNumber() {
		try {
			const cn = await fetchCreditNoteNumber();
			handleFormData('credit_note_number', cn?.number);
		} catch (error) {
			toast.error(error.message ?? 'Something went wrong!');
		}
	}

	async function getCreditNoteDetails() {
		try {
			var body = {
				ids: [id],
			};
			var { credit_note } = await fetchCreditNoteDetails(body);

			const {
				customer_id,
				credit_note_number,
				credit_note_type,
				date,
				references,
				notes,
				total_credit_amount,
				customer,
				excess_payments,
				damage_returns,
			} = credit_note;
			setCustomerList([
				{
					key: customer?.id,
					value: customer?.name,
				},
			]);
			setCreditNote((prev) => ({
				...prev,
				customer_id: customer_id,
				credit_note_number: credit_note_number,
				date: format(parseISO(date), 'yyyy-MM-dd'),
				credit_note_type: credit_note_type,
				amount_paid: credit_note_type === 3 ? total_credit_amount : 0.0,
				reference: references,
				notes: notes,
			}));
			var list = [];
			if (credit_note_type === 1) {
				list = damage_returns.map((ele) => {
					return {
						id: ele?.id,
						sales_return_id: ele?.sales_return?.id,
						date: ele?.sales_return.date,
						return_number: ele?.sales_return?.return_number,
						amount: ele?.sales_return?.bill_total,
					};
				});
				var salesReturnNumbersData = list.map((data) => {
					return {
						id: data?.sales_return_id,
						name: data?.return_number,
					};
				});
				setSalesReturnNumbers(salesReturnNumbersData);
				const closedSalesReturnList = damage_returns.map((sr) => {
					return {
						name: sr?.sales_return?.return_number,
						id: sr?.sales_return?.id,
					};
				});
				setSalesReturnList([...salesReturnList, ...closedSalesReturnList]);
			}
			if (credit_note_type === 2) {
				list = excess_payments.map((data) => {
					return {
						id: data?.id,
						pr_date: data?.date,
						payment_received_number: data?.payment_receive_number,
						totat_amount: data?.cash_handed,
						excess_payment_amount: data?.excess_payment_amount,
						invoice_number: null,
						invoice_date: null,
					};
				});
			}
			setCreditNoteTable(list);
		} catch (error) {
			toast.error(error.message ?? 'Something went wrong!');
		}
	}

	async function getSalesReturnDetails(id) {
		try {
			const body = {
				ids: [id],
			};
			var { sales_return } = await fetchSalesReturnDetails(body);
			var list = {
				sales_return_id: sales_return?.id,
				date: sales_return.date,
				return_number: sales_return?.return_number,
				amount: sales_return?.bill_total,
			};
			var salesList = [...creditNoteTable];
			salesList.push(list);
			setCreditNoteTable(salesList);
		} catch (e) {
			toast.error(e.message || 'something went wrong!');
		}
	}
	async function getcreditNoteExcessPaymentDetails() {
		try {
			var { payment_receives } = await fetchCreditNoteExcessPayment(creditNote.customer_id);

			var list = payment_receives.map((data) => {
				return {
					id: data?.id,
					pr_date: data?.date,
					payment_received_number: data?.payment_receive_number,
					totat_amount: data?.cash_handed,
					excess_payment_amount: data?.excess_payment_amount,
					invoice_number:
						data?.sales_payment_receives_invoices[0]?.invoice?.invoice_number !== undefined
							? data?.sales_payment_receives_invoices[0]?.invoice?.invoice_number
							: null,
					invoice_date:
						data?.sales_payment_receives_invoices[0]?.invoice?.date !== undefined
							? data?.sales_payment_receives_invoices[0]?.invoice?.date
							: null,
				};
			});
			setCreditNoteTable(list);
		} catch (e) {
			toast.error(e.message || 'something went wrong!');
		}
	}

	function removeSalesReturnById(id) {
		setCreditNoteTable((prevArray) =>
			prevArray.filter((data) => {
				return data.sales_return_id !== id;
			}),
		);
	}

	async function getSalesReturnListByCustomerId() {
		try {
			var body = {
				page: 1,
				page_size: 2000,
				order_by: 'desc',
				sort_by: 'created_at',
				filters: {
					dropdownList: 'credit_note',
					customer_id: creditNote.customer_id,
				},
			};
			var { sales_return } = await getSalesReturnList(body);
			const sales_return_list = sales_return.map((ele) => {
				return {
					name: ele?.return_number,
					id: ele?.id,
				};
			});
			setSalesReturnList([...salesReturnList, ...sales_return_list]);
		} catch (error) {
			toast.error(error.message || 'something went wrong!');
		}
	}

	useEffect(() => {
		if (!id) {
			handleFetchCreditNoteNumber();
		} else {
			getCreditNoteDetails();
		}
	}, [id]);

	useEffect(() => {
		if (creditNote.credit_note_type === 1 && creditNote.customer_id) {
			getSalesReturnListByCustomerId();
		}
		if (creditNote.credit_note_type === 2 && creditNote.customer_id) {
			getcreditNoteExcessPaymentDetails();
		}
	}, [creditNote.customer_id, creditNote.credit_note_type]);

	function setCustomerData() {
		if (location && location?.state) {
			const state = location?.state;
			setCustomerList([state]);
			setCreditNote((prev) => ({
				...prev,
				customer_id: state?.key,
			}));
		}
	}

	useEffect(() => {
		if (location && location?.state) {
			setCustomerData();
		}
	}, [location]);

	useEffect(() => {
		if (!autofocus) {
			setAutofocus(true);
		}
	}, [autofocus]);

	return (
		<div>
			<div
				className="max-w-1297"
				style={{ padding: '1rem 2rem 0' }}
			>
				<div className="row">
					<div className="col-4">
						<InputSelect
							options={customerList}
							label="Customer Name"
							placeholder="Customer Name"
							autoComplete="off"
							required={true}
							returnInputValue={false}
							value={creditNote?.customer_id}
							onSelect={(option) => {
								handleFormData('customer_id', option.key);
							}}
							onChange={(value) => {
								if (value === '' || value === null) {
									handleFormData('customer_id', value);
									setCreditNoteTable([]);
									setSalesReturnNumbers([]);
									setSalesReturnList([]);
								}
								setSearchCustomer(value);
							}}
							error={error?.customer_id}
							autoFocus={autofocus}
							leftIcons={
								creditNote?.customer_id
									? [
											{
												src: tooltipIcon,
												alt: 'Show Customer Details',
												onClick: () => {
													setDrawerType('customer');
													setIsDrawerOpen(true);
												},
											},
										]
									: []
							}
							onAddNew={() => {
								setIsAddCustomerModalOpen(true);
							}}
						/>
					</div>

					<div className="col-4">
						<InputField
							label="Credit Note #"
							placeholder="CN-0001"
							autoComplete="off"
							type="text"
							required={true}
							disabled={true}
							error={error?.credit_note_number}
							value={creditNote.credit_note_number}
							onChange={(value) => {
								handleFormData('credit_note_number', value);
							}}
						/>
					</div>
					<div className="col-4">
						<InputField
							label="Credit Note Date"
							placeholder="Enter Date"
							type="date"
							autoComplete="off"
							required={true}
							error={error?.date}
							autoFocus={isDateFocus}
							value={creditNote.date}
							onBlur={(e) => {
								var value = e.target.value;
								const newError = { ...error };
								var date = new Date(value);
								var currentDate = new Date();
								currentDate.setDate(currentDate.getDate() + 1);
								let year = date.getFullYear().toString();
								if (year.length === 4 && new Date(value) < new Date().setHours(0, 0, 0, 0)) {
									if (!isUsedPastDate) {
										setIsOpenPastDate(true);
									}
									setCreditNote((prev) => ({
										...prev,
										date: value,
									}));
								} else if (
									year.length === 4 &&
									new Date(value) > currentDate.setHours(0, 0, 0, 0)
								) {
									setIsOpenPastDate(false);
									newError.date = 'Date cannot be in the future';
									setError(newError);
									setCreditNote((prev) => ({
										...prev,
										date: value,
									}));
								} else {
									setCreditNote((prev) => ({
										...prev,
										date: value,
									}));
									setIsOpenPastDate(false);
									delete newError.date;
									setError(newError);
								}
							}}
							onChange={(value) => {
								const newError = { ...error };
								var date = new Date(value);
								var currentDate = new Date();
								currentDate.setDate(currentDate.getDate() + 1);
								let year = date.getFullYear().toString();
								if (year.length === 4 && new Date(value) < new Date().setHours(0, 0, 0, 0)) {
									setCreditNote((prev) => ({
										...prev,
										date: value,
									}));
								} else if (
									year.length === 4 &&
									new Date(value) > currentDate.setHours(0, 0, 0, 0)
								) {
									setIsOpenPastDate(false);
									newError.date = 'Date cannot be in the future';
									setError(newError);
									setCreditNote((prev) => ({
										...prev,
										date: value,
									}));
								} else {
									setCreditNote((prev) => ({
										...prev,
										date: value,
									}));
									setIsOpenPastDate(false);
									delete newError.date;
									setError(newError);
								}
							}}
							max={getCurrentDate()}
						/>
					</div>
				</div>
				<div
					className="row"
					style={{ marginTop: '2rem' }}
				>
					<div className={creditNote.credit_note_type === 2 ? 'col-6' : 'col-4'}>
						<InputField
							label="Reference"
							placeholder="Ref-00005"
							type="text"
							autoComplete="off"
							required={false}
							autoFocus={isReferencesFocus}
							value={creditNote.reference}
							onChange={(value) => {
								handleFormData('reference', value);
							}}
						/>
					</div>
					<div className={creditNote.credit_note_type === 2 ? 'col-6' : 'col-4'}>
						<InputSelect
							options={creditNoteTypeList}
							label="Credit Note Type"
							placeholder="Select Credit Note Type"
							required={true}
							autoComplete="off"
							disabled={false}
							returnInputValue={false}
							value={creditNote?.credit_note_type}
							onSelect={(option) => {
								if (creditNote.credit_note_type !== option.key) {
									setCreditNoteTable([]);
									setSalesReturnNumbers([]);
								}
								handleFormData('credit_note_type', option.key);
							}}
							error={error?.credit_note_type}
						/>
					</div>
					{creditNote.credit_note_type === 1 && (
						<div
							className="col-4"
							style={{ display: 'flex', flexDirection: 'column' }}
						>
							<div
								className="mb-2"
								style={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'flex-start',
								}}
							>
								<label className="form-label mb-0">{'SR#'}</label>
								<span style={{ color: 'red', marginLeft: '.2rem' }}>*</span>
							</div>
							<Multiselect
								showArrow={true}
								avoidHighlightFirstOption={true}
								isFilterEnabled={false}
								autoComplete="off"
								style={{ color: '#0000' }}
								options={salesReturnList}
								selectedValues={salesReturnNumbers}
								placeholder="Select SR#"
								onSelect={(selectedList, selectedItem) => {
									getSalesReturnDetails(selectedItem?.id);
									var returnNumberList = [...salesReturnNumbers];
									returnNumberList.push(selectedItem);
									setSalesReturnNumbers(returnNumberList);
									var errorData = { ...error };
									delete errorData.sales_return_number;
									setError(errorData);
								}}
								onRemove={(selectedList, removedItem) => {
									var returnNumberList = salesReturnNumbers.filter(
										(data) => data.id !== removedItem.id,
									);
									setSalesReturnNumbers(returnNumberList);
									removeSalesReturnById(removedItem.id);
									if (returnNumberList.length === 0) {
										var errorData = { ...error };
										errorData.sales_return_number =
											'Please select valid  sales return number from the list';
										setError(errorData);
									}
								}}
								displayValue="name"
								className={`custom-multiselect ${error.sales_return_number !== '' && error.sales_return_number !== undefined ? 'error' : ''}`}
							/>
							{error.sales_return_number !== '' && error.sales_return_number !== undefined && (
								<p className="error-text">{error.sales_return_number}</p>
							)}
						</div>
					)}
					{creditNote.credit_note_type === 3 && (
						<div className="col-4">
							<InputField
								label="Amount Paid"
								placeholder="0.00"
								autoComplete="off"
								type="text"
								required={true}
								autoFocus={false}
								error={error?.amount_paid}
								value={creditNote.amount_paid}
								onChange={(valueData) => {
									var value = valueData?.replace(/[^0-9.]/g, '');
									handleFormData('amount_paid', value);
								}}
							/>
						</div>
					)}
				</div>
				<div
					className="row"
					style={{ marginTop: '2rem' }}
				>
					<div className="col">
						<InputField
							label="Notes"
							placeholder="Enter notes or remarks (optional)"
							type="text"
							required={false}
							autoComplete="off"
							autoFocus={false}
							error={error?.notes}
							value={creditNote.notes}
							onChange={(value) => {
								handleFormData('notes', value);
							}}
						/>
					</div>
				</div>
			</div>

			{isOpenPastDate && (
				<Modal
					className="delivery-modal"
					title="Confirm Past Date"
					isOpen={isOpenPastDate}
					onClose={() => cancelUsedPastDate()}
					cancelButton={true}
				>
					<p>You are creating a transaction in the past date. Do you want to continue?</p>

					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'flex-start',
							marginTop: '20px',
						}}
					>
						<Button
							button="Proceed"
							type="button"
							className="btn btn-primary"
							onClick={confirmUsedPastDate}
						/>
						<span style={{ width: '20px' }}></span>
						<Button
							button="Cancel"
							type="button"
							className="btn btn-danger"
							onClick={() => cancelUsedPastDate()}
						/>
					</div>
				</Modal>
			)}

			{isAddCustomerModalOpen && (
				<AddCustomerModel
					setIsAddCustomerModalOpen={setIsAddCustomerModalOpen}
					isAddCustomerModalOpen={isAddCustomerModalOpen}
					setInvoice={setCreditNote}
					setCustomerList={setCustomerList}
				/>
			)}
			{
				<CustomDrawer
					isOpen={isDrawerOpen}
					onClose={() => setIsDrawerOpen(false)}
					id={drawerType === 'customer' ? creditNote.customer_id : null}
					drawerType={drawerType}
					activeDrawer={'Details'}
				/>
			}
		</div>
	);
};
export default CreditNoteForm;
